/**
 * Normaliza líneas de pedido desde API (order_products legacy o products/items nuevos).
 */
function mergeLineDisplayName(baseName, variant) {
  const base = (baseName || '').trim()
  const pres = (variant || '').trim()
  if (!base && !pres) return 'Producto'
  if (!pres || base.includes(pres)) return base || pres
  if (!base) return pres
  return `${base} — ${pres}`
}

function variantFromBlisterInfo(line) {
  const info = line.blister_info
  if (!info) return ''
  const n = info.seed_count ?? info.seedCount
  if (n == null) return ''
  const count = Number(n)
  return count > 1 ? `${count} semillas` : '1 semilla'
}

export function getOrderLineItems(order) {
  if (!order) return []
  if (Array.isArray(order.order_products) && order.order_products.length > 0) {
    return order.order_products.map((line) => ({
      ...line,
      product_name: line.product_name || 'Producto',
    }))
  }
  const products = order.products || order.items || []
  return products.map((line) => {
    const details = line.product_details || {}
    const baseName = details.name || line.product_name || ''
    const variant =
      (line.variant_display || '').trim() || variantFromBlisterInfo(line)
    return {
      id: line.id,
      product: details.id ?? line.product,
      product_name: mergeLineDisplayName(baseName, variant),
      product_image: details.image || null,
      product_brand: details.type || details.brand || '',
      quantity: line.quantity,
      price_at_time: line.price_at_time ?? line.price,
      variant_display: variant,
      blister: line.blister ?? null,
      blister_info: line.blister_info ?? null,
    }
  })
}

export function isOrderPendingPayment(order) {
  if (!order) return false
  const s = order.status
  return s === 'pending' || s === 'payment_pending'
}

export function canPayOrderWithMp(order, mercadoPagoEnabled = true) {
  if (!mercadoPagoEnabled || !isOrderPendingPayment(order)) return false
  if (order.status === 'cancelled' || order.status === 'completed' || order.status === 'paid') {
    return false
  }
  return true
}

export function canContactAdminAboutOrder(order) {
  return isOrderPendingPayment(order)
}

export function paymentMethodLabel(method) {
  return { online: 'Mercado Pago', cash: 'Acordar pago' }[method] || method || '—'
}

/**
 * Normaliza teléfono argentino para wa.me (54 + 9 + área + número).
 */
export function formatWhatsAppNumber(phone) {
  let digits = String(phone || '').replace(/\D/g, '')
  if (!digits) return null

  if (digits.startsWith('00')) digits = digits.slice(2)

  if (digits.startsWith('54')) {
    const rest = digits.slice(2)
    if (rest.startsWith('9')) return `54${rest}`
    if (rest.length === 10) return `549${rest}`
    if (rest.length === 11 && rest.startsWith('15')) return `549${rest.slice(2)}`
    return `54${rest}`
  }

  if (digits.startsWith('0')) digits = digits.slice(1)
  if (digits.startsWith('15') && digits.length >= 10) digits = digits.slice(2)
  if (digits.length === 10 && !digits.startsWith('9')) digits = `9${digits}`

  return `54${digits}`
}

export function getWhatsAppLink(phone) {
  const n = formatWhatsAppNumber(phone)
  if (!n) return null
  return `https://wa.me/${n}`
}

export function getOrderCustomerName(order) {
  if (!order) return 'Sin nombre'
  const profile = order.user_profile
  if (profile) {
    const full = [profile.first_name, profile.last_name].filter(Boolean).join(' ').trim()
    if (full) return full
    if (profile.username) return profile.username
  }
  if (order.recipient_name?.trim()) return order.recipient_name.trim()
  if (order.customer?.username) return order.customer.username
  const c = order.customer
  if (c) {
    const full = [c.first_name, c.last_name].filter(Boolean).join(' ').trim()
    if (full) return full
  }
  return order.customer_email || 'Sin nombre'
}
